import React from 'react'
import styled from 'styled-components'
import { useLanguage } from '../context/LanguageContext'
import colors from '../globalStyles.scss'
import Modal from "react-modal";
import CarouselWithCustomArrows from './CarouselWithCustomArrows';
import CallToAction from './CallToAction';
import SelectableBox from './SelectableBox';

const StyledDiv = styled.div`
.uploaded-images {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1%;
    margin-top: 1em;

}
.image-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    img {
        object-fit: cover;
        width: 100%;
        height: 200px;
        cursor: pointer;
    }
    .remove {
        position: absolute;
        top: 0;
        right: 0;
        background: ${colors.red};
        svg {
            color: ${colors.white};
            font-size: 1rem;
        }
    }

    /* Ensure all images maintain the same width */
    &:nth-last-child(1),
    &:nth-last-child(2),
    &:nth-last-child(3) {
        grid-column: span 1;
    }
}
`

const RenderImages = ({
    images,
    removeImage,
    disabled,
    openModal,
    closeModal,
    setActiveIndex,
    activeIndex,
    isModalOpen,
    hideSave = false,
}) => {
    const { text } = useLanguage();

    return (
        <StyledDiv>
            <div className='uploaded-images scroll-container' style={{ maxHeight: '600px' }}>
                {images?.map((image, index) => {
                    return (
                        <SelectableBox
                            key={index}
                            padding={'0'}
                            className='w-100'
                            removeButton={!disabled}
                            onClickRemove={() => {
                                removeImage && removeImage(index);
                            }}
                        >
                            <div
                                key={index}
                                onClick={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    openModal(index)
                                }}
                                className='image-wrapper'
                            >
                                <img
                                    src={image?.url}
                                    alt={image?.originalName}
                                    className='uploaded-image'
                                />

                            </div>
                        </SelectableBox>
                    )
                })}
            </div>


            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                style={{
                    overlay: {
                        backgroundColor: colors.backgroundOverlay,
                    },
                    content: {
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        overflow: "auto",
                        WebkitOverflowScrolling: "touch",
                        borderRadius: "4px",
                        outline: "none",
                        padding: "20px",
                        width: '100vw',
                        height: '100vh',
                        background: colors.mutedBlue,
                        display: 'flex',
                        flexDirection: 'column',
                        border: 'none'
                    },
                }}
            >
                <CarouselWithCustomArrows
                    images={images}
                    activeIndex={activeIndex}
                    setActiveIndex={setActiveIndex}
                    hideSave={hideSave}
                />
                <CallToAction
                    text={text?.modal?.close}
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        closeModal()
                    }}
                    style={{
                        marginTop: '15px',
                        alignSelf: 'start'
                    }}
                />
            </Modal>
        </StyledDiv>
    )
}

export default RenderImages